import strings from 'strings';

import { ROLEPLAY_SCENARIOS } from '../constants';

export const COPIES = strings.ai.generators.roleplay;

export const FORM_FIELDS_MAP = {
  Specialty: { key: 'specialty' },
  Subspecialty: { key: 'subspecialty' },
  Title: { key: 'title' },
  Difficulty: { key: 'difficulty' }
};

export const CALL_GOALS = [
  COPIES.scenarios.callHiringAuthority.goals.confirmHiringAuthorityInterest,
  COPIES.scenarios.callHiringAuthority.goals.gatherJobOrderInformation,
  COPIES.scenarios.callHiringAuthority.goals.obtainFeeAgreementSignature
];

export const CANDIDATE_SCENARIO_IDS = ['cold_call_hiring_authority'];

export const CANDIDATE_ROLEPLAY_SCENARIOS = ROLEPLAY_SCENARIOS.filter(type => {
  return CANDIDATE_SCENARIO_IDS.includes(type.id);
});
